module.exports = __webpack_public_path__ + "static/media/gallery-5.45a77c69.jpg";